import * as React from "react";
import { forwardRef } from "react";
const SvgPopoverArrow = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={29.094324} height={10.76244} viewBox="0 0 29.094324 10.76244" fill="none" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M 1.1957151,14.256402 14.559185,0.71191168 27.922685,14.256402 Z" fill="#ffffff" stroke="#cdd6da" clipPath="url(#clipPath427)" transform="translate(-0.02407705,-0.07223114)" /></svg>;
const ForwardRef = forwardRef(SvgPopoverArrow);
export { ForwardRef as ReactComponent };